<template>
  <div
    class="modal fade rounded-top-5"
    :id="id"
    tabindex="-1"
    aria-hidden="true"
  >
    <template v-if="modalType === 1">
      <div class="modal-dialog-centered rounded-top-5">
        <div
          class="modal-dialog modal-content card shadow-sm border-0 rounded-4"
          :class="{ [modalSize]: true }"
        >
          <div
            class="modal-content rounded-bottom-5 rounded-top-4 border-0 bg-danger"
          >
            <div class="d-flex justify-content-end w-100 p-2">
              <button
                type="button"
                :id="`btnClose-${id}`"
                class="btn"
                :class="{ 'visually-hidden': !btnClosed }"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
                <img
                  src="../assets/icons/close_whaite.png"
                  alt="icon"
                  width="24"
                  height="24"
                />
              </button>
            </div>
            <div
              class="text-white text-center mb-3"
              :class="{ 'pt-4': !btnClosed }"
            >
              <h4 class="fw-bold">{{ title }}</h4>
            </div>
            <div class="text-white mb-3 w-100 px-4" v-if="description">
              <h5 class="fw-medium fs-6">{{ description }}</h5>
            </div>
          </div>
          <div class="modal-body">
            <div class="p-1">
              <div class="d-flex justify-content-center">
                <div class="w-75">
                  <div class="row mb-4">
                    <slot></slot>
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-center"
                :class="{ 'mb-4': modalSize == 'modal-lg' }"
              >
                <div class="w-75">
                  <button
                    :disabled="button"
                    type="submit"
                    class="btn btn-sm bg-danger w-100 text-white"
                    @click="clickSubmit"
                    id="btn-click-submit"
                  >
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="modalType === 2">
      <div
        class="modal-dialog modal-content card shadow-sm border-0"
        :class="{
          [modalSize]: true,
        }"
      >
        <div class="modal-body">
          <div class="p-1">
            <div class="d-flex justify-content-end w-100">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                :id="`btnClose-${id}`"
                @click="closeModal"
              ></button>
            </div>
            <div class="d-flex justify-content-center">
              <div class="form-group mt-1 w-100">
                <div class="row">
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="modalType === 3">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header flex justify-between">
            <h5 class="modal-title">{{ title }}</h5>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                :id="`btnClose-${id}`"
                @click="closeModal"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>

          <div class="modal-body">
            <div class="row">
              <slot></slot>
            </div>
          </div>
          <div class="modal-footer border border-0 mt-1">
            <button
              class="btn btn-danger w-100 fs-8 fw-bold"
              :disabled="button"
              @click="clickSubmit()"
            >
              Simpan
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  props: {
    title: String,
    id: String,
    modalSize: String,
    button: Boolean,
    modalType: {
      type: Number,
      default: 1,
    },
    btnClosed: {
      type: Boolean,
      default: true,
    },
    description: String,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    clickSubmit() {
      this.$emit("click-submit");
    },
  },
};
</script>
